import { useQuery } from "@tanstack/react-query";

import type { GetDaoCoinMarketFeesResponse } from "@/backend/deso";
import { getDaoCoinMarketFees } from "@/backend/deso";
import {
  CREATOR_COIN_MARKET_FEES_CACHE_MAX_AGE_MS,
  CREATOR_COIN_MARKET_FEES_QUERY_KEY,
} from "@/utils/query-persistence";

export const useCreatorCoinFee = ({
  publicKey,
}: {
  publicKey: string;
  username: string;
}) => {
  const { data: creatorCoinMarketFee = null, isLoading } = useQuery({
    queryKey: [CREATOR_COIN_MARKET_FEES_QUERY_KEY, publicKey],
    queryFn: async (): Promise<GetDaoCoinMarketFeesResponse | null> => {
      try {
        const response = await getDaoCoinMarketFees(publicKey);
        const marketFee = response.data;

        if (marketFee.FeeBasisPointsByPublicKey[publicKey]) {
          return marketFee;
        }

        return null;
      } catch {
        return null;
      }
    },
    enabled: !!publicKey,
    staleTime: CREATOR_COIN_MARKET_FEES_CACHE_MAX_AGE_MS,
    gcTime: CREATOR_COIN_MARKET_FEES_CACHE_MAX_AGE_MS,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const feeBasisPointByPk =
    creatorCoinMarketFee?.FeeBasisPointsByPublicKey[publicKey];
  const founderRewardFeePercentage = feeBasisPointByPk
    ? `${feeBasisPointByPk / 100}%`
    : "";

  return {
    loading: isLoading,
    founderRewardFeePercentage,
    creatorCoinMarketFee,
  };
};
